import { PlaylistSongData } from "@/types";
import { BrowserStreamerState } from "@/types/store/clientzone";

export const state: BrowserStreamerState = {
  playlistSong: {} as PlaylistSongData,
  StopPlayer: false,
  TookWebStream: false,
  InfoWebStream: false,
}
